import { useTranslation } from "react-i18next";
import {
  PAGE_LINK_OPERATION_GUID,
  PAGE_NAME_DISCLAIMER,
} from "../../../../constants/common_constants";
import { SelectLanguageList } from "./SelectLanguageList";
import { useNavigate } from "react-router-dom";
import { FaChevronRight } from "react-icons/fa6";

interface HamburgerMenuProps {
  menuOpen: boolean;
}

export const HamburgerMenu: React.FC<HamburgerMenuProps> = ({ menuOpen }) => {
  // ページ遷移用
  const navigate = useNavigate();
  //言語切替用
  const { t } = useTranslation();

  return (
    <div
      className={`fixed top-16 right-0 h-full w-full bg-white transition-transform ease-out duration-500 ${
        menuOpen ? "translate-x-0" : "translate-x-full"
      }`}
    >
      <div className="flex w-full bg-white">
        <SelectLanguageList />
      </div>
      <div className="flex w-full border-b border-gray-500 py-3 px-5 text-lg bg-white">
        {/* 操作ガイド(外部リンク)を別タブで開く */}
        <button
          className="flex justify-between items-center w-full"
          onClick={() => {
            //navigate(PAGE_LINK_OPERATION_GUID);
            //一時的に<a>タグを作成してダウンロード。navigateで簡単に出来るならそちらに修正する
            const link = document.createElement("a");
            link.target = "_blank";
            link.href = PAGE_LINK_OPERATION_GUID;
            document.body.appendChild(link);
            link.click();
            document.body.removeChild(link);
          }}
        >
          {t("トップ画面.操作ガイド")}
          {/* 操作ガイド */}
          <FaChevronRight />
        </button>
      </div>
      <div className="flex w-full border-b border-gray-500 py-3 px-5 text-lg bg-white">
        <button
          className="flex justify-between items-center w-full"
          onClick={() => {
            navigate(`/${PAGE_NAME_DISCLAIMER}`, {
              state: { isFromTop: true },
            });
          }}
        >
          {t("トップ画面.免責事項")}
          {/* 免責事項 */}
          <FaChevronRight />
        </button>
      </div>
    </div>
  );
};
